/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const StarIcon = /*#__PURE__*/ createSvgIcon(
  'StarIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.723 1.525a.83.83 0 011.054.546L9.993 5.82h3.618a.84.84 0 01.735.348l.001.002a.82.82 0 01-.191 1.143l-3.083 2.36 1.2 3.786a.8.8 0 01-.166.81l-.009.01-.01.01a.83.83 0 01-1.131.023L8 12.022l-2.975 2.312-.012.008a.86.86 0 01-1.007-.026.832.832 0 01-.286-.885l.003-.013 1.194-3.744L1.8 7.296l-.014-.013a.86.86 0 01-.287-.645V6.61a.84.84 0 01.791-.79l.015-.001h3.652L7.2 2.029l.006-.016a.85.85 0 01.51-.485l.007-.003zM4.298 14.462h-.002l.134-.482-.132.482zM7.98 2.857L6.682 6.82H2.826l3.257 2.486-1.244 3.907 3.16-2.456 3.14 2.431-1.232-3.882 3.248-2.486H9.267L7.98 2.857z"
            fill="currentColor"
          />
        </>
      ),
      medium: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.7 1.547a.947.947 0 011.199.62l1.666 5.111 4.967-.003a.923.923 0 01.794.388.922.922 0 01-.216 1.294l-4.19 3.212 1.621 5.083a.931.931 0 01-1.475 1.03l-4.05-3.132-4.053 3.163a.934.934 0 01-.838.158.94.94 0 01-.643-1.177l.002-.006 1.618-5.094-4.207-3.213a.94.94 0 01.612-1.702h4.91L9.111 2.13a.94.94 0 01.58-.58l.009-.003zm7.656 6.728l-5.517.004L10 2.632 8.14 8.28H2.623l4.645 3.547-1.773 5.584 4.518-3.526 4.519 3.494-1.78-5.575 4.604-3.528z"
            fill="currentColor"
          />
        </>
      ),
      large: ({ id }) => (
        <>
          <path
            d="M17.81 22.5c-.24 0-.47-.08-.66-.24L12 18.28l-5.15 3.99c-.27.21-.62.27-.94.18-.56-.16-.88-.75-.72-1.31l2.05-6.48-5.35-4.09c-.26-.21-.4-.53-.39-.85.01-.28.13-.54.33-.73.21-.19.48-.28.75-.28h6.26l2.14-6.49c.11-.31.35-.55.65-.66.27-.09.56-.08.81.04.26.12.45.34.54.61l2.12 6.5h6.25c.37-.04.73.12.95.43.33.47.22 1.12-.24 1.45l-5.32 4.07 2.07 6.47c.11.33.05.71-.18.99-.18.22-.43.36-.71.38h-.11zM2.57 9.71l5.84 4.58-2.26 7.14.09.05 5.77-4.46 5.78 4.46-2.2-7.19 5.9-4.51-.04.01-.05-.08h-7.01l-2.34-7.18h-.11L9.57 9.71h-7z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default StarIcon;
